
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { WTPActionDDLAPI, WTPEquipmentNameDDLAPI } from '../../Redux/DDLSlice'

export const WTPActionDDL = (props) => {
    const { Status, setStatus,WtpEquipmentType, IsPost,IsDisabled } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(WTPActionDDLAPI({ data }))
        // }
    }, [])

    const { WTPActionData } = useSelector(state => state.WTPActionDDL)

    useEffect(() => {
        handleWTPActionDDL()
    }, [WTPActionData])

    const handleWTPActionDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPActionData && WTPActionData.table && WTPActionData.table.length > 0) {
            let list = WTPActionData.table.map((item, index) => ({
                value: item.m_wtP_MachineryActionsID,
                label: item.actionName,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setStatus({ ...Status, DDL: list })
        }
        else {
            setStatus({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor=""><b>Status</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // isDisabled={IsDisabled}
                isSearchable
                maxMenuHeight={150}
                value={{ value: Status.ID, label: Status.Label }}
                onChange={(e) => {
                    e ?
                        setStatus({ ...Status, ID: e.value, Label: e.label })
                        :
                        setStatus({ ...Status, ID: 0, Label: "Select..." })

                }}
                options={Status.DDL}
            />
        </div>
    )
}